import { ColorProps } from 'types';

// ==============================|| RCS BRAND THEME ||============================== //

const theme2: ColorProps = {
  // paper & background
  paper: '#FFFFFF',

  // ==============================|| PRIMARY (BLUE) ||============================== //
  primaryLight: '#E8EAF6',
  primaryMain: '#2F317A',     // Logo blue
  primaryDark: '#252760',
  primary200: '#8B8DC3',
  primary800: '#1B1D4E',

  // ==============================|| SECONDARY (RED) ||============================== //
  secondaryLight: '#FDEBEC',
  secondaryMain: '#EF3139',   // Logo red
  secondaryDark: '#D9262E',
  secondary200: '#F79AA0',
  secondary800: '#B91C23',

  // ==============================|| SUCCESS ||============================== //
  successLight: '#E7F8EC',
  success200: '#7EDB97',
  successMain: '#22C55E',
  successDark: '#16A34A',

  // ==============================|| ERROR ||============================== //
  errorLight: '#FCE8E8',
  errorMain: '#DC2626',
  errorDark: '#B91C1C',

  // ==============================|| ORANGE ||============================== //
  orangeLight: '#FFF3E8',
  orangeMain: '#FB923C',
  orangeDark: '#EA580C',

  // ==============================|| WARNING ||============================== //
  warningLight: '#FEF3C7',
  warningMain: '#F59E0B',
  warningDark: '#D97706',

  // ==============================|| GREY ||============================== //
  grey50: '#F9FAFB',
  grey100: '#F3F4F6',
  grey200: '#E5E7EB',
  grey300: '#D1D5DB',
  grey500: '#6B7280',
  grey600: '#4B5563',
  grey700: '#374151',
  grey900: '#111827',

  // ==============================|| DARK THEME ||============================== //
  darkBackground: '#0E1228',
  darkPaper: '#070B1D',

  darkLevel1: '#12172F',
  darkLevel2: '#1A2142',

  // Dark primary
  darkPrimaryLight: '#E5E7F7',
  darkPrimaryMain: '#6770B8',
  darkPrimaryDark: '#5660A6',
  darkPrimary200: '#A8B0DB',
  darkPrimary800: '#404A8A',

  // Dark secondary
  darkSecondaryLight: '#FDEBEC',
  darkSecondaryMain: '#EF3139',
  darkSecondaryDark: '#D9262E',
  darkSecondary200: '#F79AA0',
  darkSecondary800: '#B91C23',

  // Text
  darkTextTitle: '#F3F4F6',
  darkTextPrimary: '#E5E7EB',
  darkTextSecondary: '#CBD5E1'
};

export default theme2;